import axios from 'axios'

export const getAllBlogs = (params) => {
  let remoteUrl = 'blogs'

  return axios.get(remoteUrl, {params: params})
}

export const getBlog = (id, params) => {
  let remoteUrl = 'blogs/' + id

  return axios.get(remoteUrl, {params: params})
}

export const addBlog = (data) => {
  let remoteUrl = 'blogs'
  return axios.post(remoteUrl, data)
}

export const editBlog = (id, data) => {
  let remoteUrl = 'blogs/' + id
  return axios.put(remoteUrl, data)
}

export const deleteBlog = (id) => {
  let remoteUrl = 'blogs/' + id
  return axios.delete(remoteUrl)
}

export const getBlogHelpers = () => {
  return axios.get('helpers/blogs')
}



// WEBPACK FOOTER //
// ./src/api/blogs.js